<div class="screen-only cycle__child spacing--padding-all spacing--margin-all" data-test="reports">
  <div class="flex--column">
    <mat-form-field
      class="flex__child--auto"
      *ngIf="propagationCompanies$ | async as propagationCompanies"
    >
      <mat-label>{{ 'reports.propagation-company' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'reports.propagation-company' | translate }}"
        [(ngModel)]="selectedPropagationCompany"
        (selectionChange)="selectPropagationCompany()"
        data-test="reports__propagation-company"
      >
        <mat-option
          *ngFor="let propagationCompany of propagationCompanies"
          [value]="propagationCompany"
        >
          {{ propagationCompany.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="spacing--margin-top mat-button-row">
      <button
        type="submit"
        mat-flat-button
        class="flex__child"
        color="primary"
        (click)="print()"
        data-test="reports__print"
      >
        {{ 'reports.print' | translate }}
      </button>
    </div>
  </div>
</div>

<agr-print-page
  class="print-only"
  orientation="landscape"
  [footerText]="'reports.print-title' | translate"
  customizedLogoSrc="/assets/images/pluvita_logo.jpg"
  [showAgrifirmLogo]="false"
>
  <div class="print--padding">
    <ng-container *ngFor="let report of cycleReport">
      <h3>{{ 'reports.general-title' | translate }}</h3>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column general-header">
          <label class="text--bold">{{ 'reports.location' | translate }}:</label>
          <label class="text--bold">{{ 'breed' | translate }}:</label>
          <label class="text--bold">{{ 'gender' | translate }}:</label>
          <label class="text--bold">{{ 'reports.birthdate' | translate }}:</label>
        </div>
        <div class="flex--column general-header">
          <label>{{ report.location }}</label>
          <label>{{ report.breed }}</label>
          <label>{{ report.gender | translate }}</label>
          <label>{{ report.chickBirthDate | agrDate }}</label>
        </div>
        <div class="flex--column general-header">
          <label class="text--bold">{{ 'reports.barn-name' | translate }}:</label>
          <label class="text--bold">{{ 'reports.section-name' | translate }}:</label>
          <label class="text--bold">{{ 'reports.feedsupply.label' | translate }}:</label>
          <label class="text--bold">{{ 'reports.watersupply.label' | translate }}:</label>
        </div>
        <div class="flex--column general-header">
          <label>{{ report.barnName }}</label>
          <label>{{ report.sectionName }}</label>
          <label>{{ 'reports.feedsupply.' + report.feedSupply | translate }}</label>
          <label>{{ 'reports.watersupply.' + report.waterSupply | translate }}</label>
        </div>
        <div class="flex--column general-header">
          <label class="text--bold">{{ 'reports.propagation-company-name' | translate }}:</label>
        </div>
        <div class="flex--column general-header">
          <label>{{ report.propagationCompanyName }}</label>
        </div>
      </div>
      <h3>{{ 'reports.table-title' | translate }}</h3>
      <div class="page-break-after">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>{{ 'reports.table.nr-of-animals' | translate }}</th>
              <th colspan="2">{{ 'reports.table.animalweight' | translate }}</th>
              <th>{{ 'reports.table.uniformity' | translate }}</th>
              <th colspan="2">{{ 'reports.table.feedintake' | translate }}</th>
              <th>{{ 'reports.table.waterfeedratio' | translate }}</th>
              <th colspan="2">{{ 'reports.table.light' | translate }}</th>
              <th colspan="4">{{ 'reports.table.cumulative-mortality-percentage' | translate }}</th>
            </tr>
            <tr>
              <th>{{ 'reports.table.weeknr' | translate }}</th>
              <th>{{ 'reports.table.end-week' | translate }}</th>
              <th>{{ 'reports.table.koppel' | translate }}</th>
              <th>{{ 'reports.table.norm' | translate }}</th>
              <th>{{ 'reports.table.koppel' | translate }}</th>
              <th>{{ 'reports.table.koppel' | translate }}</th>
              <th>{{ 'reports.table.norm' | translate }}</th>
              <th>{{ 'reports.table.koppel' | translate }}</th>
              <th>{{ 'reports.table.light-hours' | translate }}</th>
              <th>{{ 'reports.table.light-intensity' | translate }}</th>
              <th>{{ 'reports.table.mortality-percentage-death' | translate }}</th>
              <th>{{ 'reports.table.mortality-percentage-selection' | translate }}</th>
              <th>{{ 'reports.table.mortality-percentage-sexerror' | translate }}</th>
              <th>{{ 'reports.table.mortality-percentage-total' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let week of report.weekData">
              <td>{{ week.weeknr | agrNumber: '1.0-0' }}</td>
              <td>{{ week.numberOfAnimals | agrNumber: '1.0-0' }}</td>
              <td>{{ week.animalWeight | agrNumber: '1.0-0' }}</td>
              <td>{{ week.animalWeightReference | agrNumber: '1.0-0' }}</td>
              <td>{{ week.uniformity | agrNumber: '1.0-1' }}</td>
              <td>{{ week.feedintake | agrNumber: '1.0-0' }}</td>
              <td>{{ week.feedintakeReference | agrNumber: '1.0-0' }}</td>
              <td>{{ week.waterfeedRatio | agrNumber: '1.0-2' }}</td>
              <td>{{ week.numberOfHoursLight | agrNumber: '1.0-1' }}</td>
              <td>{{ week.lightIntensity | agrNumber: '1.0-0' }}</td>
              <td>{{ week.mortalityPercentageDeath | agrNumber: '1.0-2' }}</td>
              <td>{{ week.mortalityPercentageSelection | agrNumber: '1.0-2' }}</td>
              <td>{{ week.mortalityPercentageSexError | agrNumber: '1.0-2' }}</td>
              <td>{{ week.cumulativeMortalityPercentage | agrNumber: '1.0-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page-break-after">
        <p class="text--bold">
          {{ 'reports.weight' | translate }} {{ 'reports.section-name' | translate }}:
          {{ report.sectionName }} {{ report.breed }} {{ report.gender }} ({{
            report.chickBirthDate | agrDate
          }})
        </p>
        <agr-chart [options]="chartOptions" [dataSource]="report.chartSeries"></agr-chart>
      </div>
    </ng-container>
  </div>
</agr-print-page>
